import React from 'react'

import {useIsMobile} from '../../../../hooks'
import {ModalDesktop} from './ModalDesktop'
import {ModalMobile} from './ModalMobile'
import {Props} from './types'

export function Modal(props: Props): React.ReactElement<Props> {
  const isMobile = useIsMobile()

  return isMobile ? <ModalMobile {...props} /> : <ModalDesktop {...props} />
}
